import { auth, companiesCollection } from "../firebase.config";

const state = {
  company: null,
  gettingCompany: false
};

const mutations = {
  SET_COMPANY(state, user) {
    state.company = user;
  },
  SET_GETTING_COMPANY(state, boolean) {
    state.gettingCompany = boolean;
  }
};

const actions = {
  createNewCompany({ rootState, dispatch, commit }, name) {
    const companyDoc = {
      name: name,
      members: [auth.currentUser.uid],
      teams: ["Marketing", "Operations", "Product", "Design", "Engineering"],
      updateDay: "Monday",
      updateTime: "8:00pm",
      admins: [auth.currentUser.uid]
    };

    companiesCollection.add(companyDoc).then(doc => {
      commit("SET_COMPANY", companyDoc);
      dispatch("updateUser", {
        uid: auth.currentUser.uid,
        change: { companyId: doc.id }
      });
    });
  },
  getCompany({ commit, dispatch }, id) {
    commit("SET_GETTING_COMPANY", true);
    return companiesCollection
      .doc(id)
      .get()
      .then(companyDoc => {
        commit("SET_COMPANY", companyDoc.data());
        commit("SET_GETTING_COMPANY", false);
        return companyDoc.data();
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t get your company info",
          message: "Please check your wifi and try again",
          type: "error-important",
          icon: "wifi-off"
        };
        dispatch("fireNotification", notification);
        commit("SET_GETTING_COMPANY", false);
      });
  },
  updateCompany({ dispatch }, payload) {
    companiesCollection
      .doc(payload.id)
      .update(payload.change)
      .then(() => {
        dispatch("getCompany", payload.id);
      })
      .catch(() => {
        let notification = {
          title: "Couldn’t update the server",
          message: "Please check your wifi and try again",
          type: "error",
          icon: "wifi-off"
        };
        dispatch("fireNotification", notification);
      });
  }
};

const getters = {
  gettingCompany: state => state.gettingCompany,
  company: state => state.company
};

const companiesModule = {
  state,
  mutations,
  actions,
  getters
};

export default companiesModule;
